import { useEffect } from 'react'

import { useAppDispatch } from '@/src/store/hooks'
import { setWindowIsActive } from '@/src/store/slices/window'

export const useWindowIsActive = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    let isBlur: boolean = true
    let isFocus: boolean = true
    let isVisible: boolean = true

    function handleActivity(isActive: boolean) {
      if (isActive) {
        dispatch(setWindowIsActive(true))
      } else {
        dispatch(setWindowIsActive(false))
      }
    }

    function handleVisibilityChange(this: Document) {
      if (this.hidden) {
        dispatch(setWindowIsActive(false))
      } else {
        dispatch(setWindowIsActive(true))
      }
    }

    const handleActivityFalse = () => handleActivity(false)
    const handleActivityTrue = () => handleActivity(true)

    window.addEventListener('blur', handleActivityFalse)
    window.addEventListener('focus', handleActivityTrue)

    document.addEventListener('blur', handleActivityFalse)
    document.addEventListener('focus', handleActivityTrue)

    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      window.removeEventListener('blur', handleVisibilityChange)
      window.removeEventListener('focus', handleActivityFalse)

      document.removeEventListener('blur', handleActivityFalse)
      document.removeEventListener('focus', handleActivityTrue)

      document.removeEventListener('visibilitychange', handleActivityTrue)
    }
  }, [])
}
